import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private readonly appInsightsService: AppInsightsService) {}

  handleError(error: any): void {
    this.appInsightsService.logException(error);
    console.error(error);
  }
}